import React from 'react';
import { SalesPage } from './pages/SalesPage';
export function App() {
  return <div className="min-h-screen bg-nightBlue selection:bg-gold selection:text-nightBlue" data-id="element-0">
      <SalesPage data-id="element-1" />
    </div>;
}